import 'core-js/shim';
import {Component, OnInit} from '@angular/core';
import {SedeService} from 'src/app/service/sede.service';
import {Sede} from '../model/sede';
import {icon, latLng, marker, tileLayer} from 'leaflet';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Search} from '../common/search';
import {MultilinguaService} from '../service/multilingua.service';
import {MenuService} from '../service/menu.service';
import {getOtherLangs} from '../constants/functions';
import {SeoService} from '../service/seo.service';

@Component({
    selector: 'app-servizi-mondo',
    templateUrl: './servizi-mondo.component.html',
    styleUrls: ['./servizi-mondo.component.css']
})
export class ServiziMondoComponent implements OnInit {

    public listeSedi: Array<{ sedi: Array<Sede>; paese: string }> = [];
    public lingua: string;
    public pageName: string;
    public loading = true;

    public options: any;
    private streetMaps: any;
    private wMaps: any;
    public mapData = [];
    public mapkeys = [];
    public simpleList: Sede[] = [];
    public component: string = null;
    public base_path: string;
    public place: string;
    public index = -1;

    public paesiMap = new Map<string, Sede[]>();

    constructor(private sedeService: SedeService,
                private seoService: SeoService,
                private multilingueService: MultilinguaService,
                private menuService: MenuService,
                private location: Location,
                public activatedRoute: ActivatedRoute) {
        this.base_path = window.location.pathname;
    }

    handleChange(e) {
        // console.log(e);
        const index = e.index;
        const key = this.mapkeys[index];
        const path = this.base_path + '?place=' + key;
        this.simpleList = this.paesiMap.get(key);
        window.history.replaceState({}, '', path);
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(data => {
            this.lingua = data['lang'];
        });
        this.activatedRoute.queryParamMap
            .subscribe(queryParams => {
                this.place = queryParams.get('place');
                if (!this.place) {
                    this.place = '';
                }
            });
        this.load();
    }

    load() {
        this.activatedRoute.url.subscribe(() => {
            const url = this.location.path().split('/');
            this.pageName = url.pop();
            getOtherLangs(this.multilingueService, this.lingua, this.menuService, this.seoService, this.pageName);
            this.sedeService.search = new Search<Sede>(Sede);
            this.sedeService.search._sort = 'paese ASC, denominazione ASC';
            this.sedeService.search._.lang = this.lingua;
            this.sedeService.getAllList().subscribe(sedi => {
                // console.log(sedi);
                // create circle for office
                for (let i = 0; i < sedi.length; i++) {
                    if (this.paesiMap.has(sedi[i].paese)) {
                        const sedixx: Sede[] = this.paesiMap.get(sedi[i].paese);
                        sedixx.push(sedi[i]);
                        this.paesiMap.set(sedi[i].paese, sedixx);
                    } else {
                        this.mapkeys.push(sedi[i].paese);
                        const sedixx: Sede[] = [];
                        sedixx.push(sedi[i]);
                        this.paesiMap.set(sedi[i].paese, sedixx);
                    }

                    const mark = marker([sedi[i].latitudine, sedi[i].longitudine], {
                        icon: icon({
                            iconSize: [25, 41],
                            iconAnchor: [13, 41],
                            iconUrl: 'leaflet/marker-icon.png',
                            shadowUrl: 'leaflet/marker-shadow.png'
                        }),
                        title: sedi[i].denominazione,
                    });
                    mark.bindPopup(sedi[i].denominazione);
                    this.mapData.push(mark);
                }
                this.simpleList = this.paesiMap.get(this.mapkeys[0]);
            });
            // Define our base layers so we can reference them multiple times
            this.streetMaps = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                detectRetina: true,
                attribution: ''
            });
            this.wMaps = tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
                detectRetina: true,
                attribution: ''
            });

            this.options = {
                layers: [this.streetMaps, this.wMaps],
                zoom: 3,
                center: latLng([46.879966, 67.726909])
            };
            this.loading = false;
        });
    }


}
